import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import { WhatsAppButton } from "@/components/home/StoreInfo";
import OrderPlaced from "@/pages/OrderPlaced";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Returns from "@/pages/Returns";
import Legal from "@/pages/Legal";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const AuthPage = ({ children }) => <div className="min-h-[70vh] flex items-center justify-center py-16 px-4">{children}</div>;

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <CartProvider>
          <ScrollTop />
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tienda" element={<Catalog key="shop" />} />
                <Route path="/outlet" element={<Catalog outlet key="outlet" />} />
                <Route path="/producto/:id" element={<ProductDetail />} />
                <Route path="/devoluciones" element={<Returns />} />
                <Route path="/legal/:doc" element={<Legal />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/pedido/:id" element={<OrderPlaced />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/cuenta" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
                <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppButton />
          </div>
          <CartDrawer />
          <Toaster position="top-center" richColors />
        </CartProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
